import { useAppSelector } from "../../app/hooks";
import CourseRoster from "./CourseRoster";
import { ManageCourseWritersViewModel } from "./manageCourseApiSlice";

interface Props {
	rosterData: ManageCourseWritersViewModel;
}

export default function PrintRosterDocument({ rosterData }: Props) {
	const { course } = useAppSelector((state) => state.user);
	const getPageMargins = () => {
		return `@page { margin: 40px 50px 40px 50px !important; size: portrait}`;
	};

	return (
		<div>
			<style>{getPageMargins()}</style>
			<h2 className="mb-3">{course?.name} Roster</h2>
			<CourseRoster rosterData={rosterData} />
		</div>
	);
}
